import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";
import { fetchClientProjects } from "../../services/clientProjectService";
import { CardSkeleton } from "../../components/Loading";
import "./client.css";

export default function ClientDashboard() {
    const { user, signOut, isSupabaseReady, isLoading } = useClientAuth();
    const navigate = useNavigate();

    const [projects, setProjects] = useState([]);
    const [error, setError] = useState("");
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const loadProjects = async () => {
            setIsFetching(true);
            setError("");
            try {
                const data = await fetchClientProjects();
                if (isMounted) {
                    setProjects(data);
                }
            } catch (loadError) {
                if (isMounted) {
                    setError(loadError.message ?? "Projeler yüklenirken bir hata oluştu.");
                }
            } finally {
                if (isMounted) {
                    setIsFetching(false);
                }
            }
        };

        if (!isLoading) {
            loadProjects();
        }

        return () => {
            isMounted = false;
        };
    }, [isLoading, isSupabaseReady]);

    const handleSignOut = async () => {
        if (!isSupabaseReady) {
            navigate("/client/login", { replace: true });
            return;
        }

        try {
            await signOut();
            navigate("/client/login", { replace: true });
        } catch (signOutError) {
            setError(signOutError.message ?? "Çıkış yapılamadı. Lütfen tekrar deneyin.");
        }
    };

    const handleProjectClick = (projectId) => {
        navigate(`/client/projects/${projectId}`);
    };

    return (
        <div className="client-dashboard">
            <header className="client-dashboard__header">
                <div className="client-dashboard__meta">
                    <span>Modelerman Client Hub</span>
                    <h1 className="client-dashboard__title">Projeleriniz</h1>
                    {user?.email && <span>Giriş yapan hesap: {user.email}</span>}
                    {!isSupabaseReady && (
                        <span>
                            Demo modu: Supabase yapılandırması bulunamadı. Örnek projeler gösteriliyor.
                        </span>
                    )}
                </div>
                <button className="client-dashboard__signout" type="button" onClick={handleSignOut}>
                    Çıkış yap
                </button>
            </header>

            {error && <div className="client-form__error" style={{ maxWidth: "640px" }}>{error}</div>}

            <section className="client-dashboard__grid">
                {isFetching ? (
                    <>
                        <CardSkeleton />
                        <CardSkeleton />
                        <CardSkeleton />
                    </>
                ) : projects.length === 0 ? (
                    <div className="client-empty">
                        Henüz atanmış bir projeniz bulunmuyor. Talebinizin onaylanması sonrasında proje kartı burada görünecek.
                    </div>
                ) : (
                    projects.map((project) => (
                        <article
                            key={project.id}
                            className="client-project-card"
                            onClick={() => handleProjectClick(project.id)}
                            role="button"
                        >
                            <span className="client-project-card__status">{project.status || "Durum belirtilmedi"}</span>
                            <h2 className="client-project-card__title">{project.title}</h2>
                            <p className="client-project-card__summary">{project.summary}</p>
                            <div className="client-project-card__dates">
                                {project.kickoffDate && <span>Kickoff: {project.kickoffDate}</span>}
                                {project.deliveryDate && <span>Teslim: {project.deliveryDate}</span>}
                                {project.updatedAt && <span>Güncellendi: {new Date(project.updatedAt).toLocaleDateString()}</span>}
                            </div>
                        </article>
                    ))
                )}
            </section>
        </div>
    );
}
